import { combineReducers } from "redux";
import walletConnection from './walletdeatils/walletConnection';
import avatarTool from './toolpage/avatarTool';


export default combineReducers({
    walletConnection,
    avatarTool
});